export enum UserEditFormType {
  personal = 'personal',
  addresses = 'addresses',
  contacts = 'contacts',
  credentials = 'credentials',
  payments = 'payments',
  params = 'params',
  protected = 'protected',
}
